import styled from "styled-components";

export const StyledMessageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

export const StyledMessageCenter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 2rem;
  height: calc(100vh - 300px);
  overflow-y: auto;
  padding-right: 1rem;
  background: #f5f6f7;
`;

export const StyledMessageMessageCenterHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 2rem 1rem;
  font-weight: 600;
  font-size: 16px;
`;

export const ContactAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 1rem;
`;
